export default __webpack_public_path__ + "static/media/games.030d9e2e.jpeg";